import { render, staticRenderFns } from "./tableHoliday.vue?vue&type=template&id=67ef9127&scoped=true"
import script from "./tableHoliday.vue?vue&type=script&lang=js"
export * from "./tableHoliday.vue?vue&type=script&lang=js"
import style0 from "./tableHoliday.vue?vue&type=style&index=0&id=67ef9127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef9127",
  null
  
)

export default component.exports